<template>
  <div id="scribble-menu-window">
    <ColorPicker
      v-if="colorPickerData"
      :color-picker-data="colorPickerData"
      @colorChange="handleColorChange"
    />
    <div class="pt-2 text-left">
      <strong class="strokeWeightTitle">
        SIZE
      </strong>
      <v-slider
        v-model="strokeWeight"
        show-ticks="always"
        min="2"
        max="18"
        step="4"
        tick-size="3"
        thumb-label
        color="#C5C5C5"
        :thumb-color="currentColor"
        :thumb-size="(strokeWeight + 4) * 1.2"
        hide-details
      >
        <template #thumb-label>
          {{ `${strokeWeight}px` }}
        </template>
      </v-slider>
    </div>
  </div>
</template>

<script>
import ColorPicker from '@/components/InfoWindow/sections/Toolbar/ColorPicker.vue';
import {ColorPickerOptions} from '@/services/GraphicService';
import * as colors from '@/lib/colors';
import {setColor, getColor, setWeight} from '@/lib/toolbox/drawMode';

export default {
  name: 'ScribbleBox',
  components: {
    ColorPicker,
  },
  data() {
    return {
      colorPickerData: new ColorPickerOptions({
        title: 'Color',
        setColor,
        getColor,
        allowTransparent: false,
        availableColors: [
          colors.pink,
          colors.red,
          colors.orange,
          colors.yellow,
          colors.green,
          colors.blue,
          colors.purple,
          colors.brown,
          colors.black,
          colors.gray,
        ],
      }),
      strokeWeight: 6,
      currentColor: getColor() || colors.blue,
    };
  },
  watch: {
    strokeWeight: {
      handler(newVal) {
        setWeight(newVal);
      },
      immediate: true,
    },
  },
  methods: {
    handleColorChange(color) {
      this.currentColor = color;
    },
  },
};
</script>

<style scoped lang="scss">
#scribble-menu-window {
  padding: 12px;
  height: 128px;
}
.strokeWeightTitle {
  font-size: 12px;
  color: main.$npGray;
  margin-left: 4px;
}
</style>

